const digitsOnly = (value: string) => value.replace(/\D/g, '');

export const normalizePhone = (input: string): string | null => {
  const digits = digitsOnly(input);

  if (/^(55)?\d{2}9\d{8}$/.test(digits)) {
    const local = digits.startsWith('55') ? digits : `55${digits}`;
    return `+${local}`;
  }

  if (/^(351)?9\d{8}$/.test(digits)) {
    const local = digits.startsWith('351') ? digits : `351${digits}`;
    return `+${local}`;
  }

  return null;
};

export const formatPhoneMask = (input: string): string => {
  const digits = digitsOnly(input);

  if (digits.startsWith('351') || (digits.length <= 9 && digits.length >= 4)) {
    const d = digits.startsWith('351') ? digits.slice(3) : digits;
    const p1 = d.slice(0, 3);
    const p2 = d.slice(3, 6);
    const p3 = d.slice(6, 9);
    return `${digits.startsWith('351') ? '+351 ' : ''}${p1}${p2 ? ` ${p2}` : ''}${p3 ? ` ${p3}` : ''}`.trim();
  }

  const d = digits.startsWith('55') ? digits.slice(2) : digits;
  const dd = d.slice(0, 2);
  const p1 = d.slice(2, 7);
  const p2 = d.slice(7, 11);
  return `${digits.startsWith('55') ? '+55 ' : ''}${dd ? `(${dd}) ` : ''}${p1}${p2 ? `-${p2}` : ''}`.trim();
};

export const isValidPhone = (input: string) => normalizePhone(input) !== null;
